import { render, staticRenderFns } from "./WaitingPaymentModal.vue?vue&type=template&id=3a627957&"
import script from "./WaitingPaymentModal.vue?vue&type=script&lang=ts&"
export * from "./WaitingPaymentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports